module.exports = __webpack_public_path__ + "static/media/pic41.9d3f84b4.jpg";